// ad-rotate — 广告轮转算法。
// fixed: 按后端下发顺序取前 cap 条。
// random: 按 CRC-32(identity:hourBucket) 哈希做起始位偏移,同一小时同一身份结果稳定。
import { crc32 } from 'hash-wasm'

export type Ad = { id: string; image_url: string; target_url: string; slogan: string }

/**
 * computeVisible:按排序模式算出该广告位实际渲染的广告(长度 ≤ cap)。不足 cap 由调用方补占位。
 * @param ads       后端下发的广告列表
 * @param orderMode 'fixed' | 'random'
 * @param identity  身份串(登录 uuid / 匿名 device token);用于 random 偏移稳定性
 * @param cap       广告位容量(AD_CAP[slot])
 */
export async function computeVisible(
  ads: Ad[],
  orderMode: 'fixed' | 'random',
  identity: string,
  cap: number,
): Promise<Ad[]> {
  const N = ads.length
  if (N === 0) return []
  if (orderMode === 'fixed') return ads.slice(0, cap)
  const hourBucket = Math.floor(Date.now() / 3_600_000)
  const hex = await crc32(`${identity}:${hourBucket}`)
  const start = parseInt(hex, 16) % N
  const rotated = [...ads.slice(start), ...ads.slice(0, start)]
  return rotated.slice(0, cap)
}
